import { useLayoutEffect, useRef, useState } from 'react';
import { toggleBodyScroll } from '../utils/toggleBodyScroll';
const doc = document;
const body = doc.body;
const fhButton = doc.querySelector('.fixed-help__container');
body._nbOpenedModals = body._nbOpenedModals ?? 0;
export const useModal = (initialState = false) => {
    const [opened, setOpened] = useState(initialState);
    const prevState = useRef(false);
    const openFn = () => {
        setOpened(true);
    };
    const closeFn = () => {
        setOpened(false);
    };
    useLayoutEffect(() => {
        if (prevState.current === opened)
            return;
        if (opened) {
            toggleBodyScroll(true);
            fhButton?.setAttribute('hidden', 'true');
            body._nbOpenedModals = body._nbOpenedModals + 1;
        }
        else {
            body._nbOpenedModals = Math.max(0, body._nbOpenedModals - 1);
            if (body._nbOpenedModals < 1) {
                toggleBodyScroll(false);
                fhButton?.removeAttribute('hidden');
            }
        }
        prevState.current = opened;
    }, [opened]);
    return [opened, openFn, closeFn];
};
